import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Navigate, Route, useLocation } from "react-router-dom";
import { PathStateObject } from "../Utils/Models/routesModel";
import StoreStateModel from "../Utils/Models/store";
import { pathRoute } from "../Utils/Routes/routes";
import { signOutUser } from "../../store/actions";
import { hasSomeAuthorization, isActionsAllowed } from "./actionsCheck";
interface Props {
  autorization: string[];
  path: string;
  isAuthenticated: boolean;
  isVerifying: boolean;
  scopes: string[];
  element: JSX.Element;
  hasPermissionPortalAccessRead: boolean;
}
export default function PrivateRoute({
  path,
  autorization,
  isAuthenticated,
  isVerifying,
  scopes,
  element,
  hasPermissionPortalAccessRead,
}: Props) {
  const dispatch = useDispatch();
  let authorized = false;
  /**
   * this is to avoid showing a page if the user doesn't have some of the authorization to see it. This authorization is set in the route model
   */
  if (isAuthenticated && hasSomeAuthorization(autorization, scopes)) {
    authorized = true;
  }

  useEffect(() => {
    if (!isVerifying && !hasPermissionPortalAccessRead) {
      dispatch(signOutUser());
    }
  }, [isVerifying]);

  const location = useLocation();
  return (
    // <Route
    //   path={path}
    //   element={
    <>
      {isVerifying ? null : isAuthenticated ? (
        authorized ? (
          element
        ) : (
          <Navigate to={pathRoute.Dashboard} replace />
        )
      ) : (
        <Navigate
          to={pathRoute.SignIn.Index}
          replace
          state={{ from: location.pathname } as PathStateObject}
        />
      )}
    </>
    // }
    // />
  );
}
